import styled, { css } from 'styled-components';
import { device } from 'commons';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  &.large {
    gap: 20px;
  }
`;

export const CardTitle = styled.div<{ $isLoading: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;

  .loader {
    position: absolute;
    display: none;
    align-items: center;
    justify-content: center;
    left: -24px;
  }

  ${({ $isLoading }) =>
    $isLoading &&
    css`
      opacity: 0.7;

      .loader {
        display: flex;
      }
    `}
`;

export const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;

  @media (max-width: ${device.desktop}px) {
    gap: 10px;
  }
`;
